import PatientInfoSection from "./sections/patient-info-section";
import { Error } from "@analyticsMD/quil";
import { css } from "@emotion/css/dist/emotion-css.cjs";
import type { ReactElement, ReactNode } from "react";
import { logError } from "./bugsnag-client";

const img_styles = {
  base: css`
    height: 8.75rem;
    width: 15rem;
    padding-top: 7.5rem;
  `,
  txt: css`
    width: 15rem;
    text-align: center;
    font-size: 12px;
    color: black;
  `,
};

interface ErrorPageProps {
  error?: Error | null;
  includeHeader?: boolean;
  closeButtonCmpt?: ReactNode;
  showActualError?: boolean;
}

const ErrorPage = ({
  error = null,
  includeHeader = false,
  closeButtonCmpt = null,
  showActualError = false,
}: ErrorPageProps): ReactElement => {
  if (error) logError(error);
  const message =
    error?.message && showActualError
      ? error.message
      : "Whoops, something went wrong please refresh or try again";
  return (
    <div>
      {includeHeader && (
        <PatientInfoSection showError closeButtonCmpt={closeButtonCmpt} />
      )}
      <Error
        message={message}
        imgStyles={img_styles.base}
        messageStyles={img_styles.txt}
      />
    </div>
  );
};

export default ErrorPage;
